<template>
  <div class="toast" v-if="showTip">{{ toastText }}</div>
</template>

<script>
export default {
  data() {
    return {
      showTip: false,
      toastText: '',
      clearTip: null,
      // 默认显示时间
      defaultTime: 500
    }
  },
  methods: {
    showToast(text, time = this.defaultTime) {
      this.showTip = true
      this.toastText = text
      clearTimeout(this.clearTip)
      this.clearTip = setTimeout(() => {
        this.showTip = false
        this.toastText = ''
      }, time)
    }
  }
}
</script>

<style>
.toast {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: #333;
  color: #fff;
  padding: 20px 20px;
  border-radius: 5px;
  z-index: 9999;
  /* text-align: center; */
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>